import React, {
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import { useMap } from "react-leaflet";
import { useSelector } from "react-redux";
import { livetrackingcontext } from "../../../../../context/LiveTrackingContext";
import { popupcontext } from "../../../../../context/Popupscontext";
import { useGetUsersDeviceQuery } from "../../../../../Redux/service/Devices";
import Loader from "../../../../Helpers/Loader/Loader";
import { filtrationcontext } from "../../../../../context/Filtercontext";
import { useGetUserGroupQuery } from "../../../../../Redux/service/Groups/Groups";
import { useGetDevicesByGroupQuery } from "../../../../../Redux/service/Groups/GroupsBack";
import { draggablecontext } from "../../../../../context/Draggablecontext";
import trans from "../../../../../utils";
import usePermission from "../../../../../hooks/usePermission";
import { Checkbox } from "antd";

const ITEM_HEIGHT = 64; // row height
const BUFFER = 3;

export default function TrackedTableRow({ userid, setImei, imei }) {
	let {
		handleShowObject,
		objectselect,
		setObjectselect,
		setHistoryPlayback,
		reloadData,
		setReloadData,
		handleClose,
	} = useContext(popupcontext);
	let {
		trackingType,
		multipleSelect,
		setVehicleIds,
		vehiclesIds,
		shownData,
		setShownData,
		selectedId,
		setSelectedId,
	} = useContext(livetrackingcontext);
	console.log("Shown Data", shownData);
	const shownDataByUser = shownData?.[userid] || [];
	useEffect(() => {
		// Cleanup function runs when component unmounts
		return () => {
			setObjectselect(false);
			setImei(null);
		};
	}, []);
	let { filter, setSearchQuery } = useContext(filtrationcontext);
	const [containerHeight, setContainerHeight] = useState(0);

	useEffect(() => {
		if (!objectselect) {
			setImei(null);
		}
	}, [objectselect]);

	const [permission, setpermission] = useState(null);
	useEffect(() => {
		setpermission("LIVETRACKINGHISTORY");
	}, []);

	const { view, edit, delete: remove } = usePermission(permission);

	const inf = useSelector((state) => state.users.user);
	const { data: Groups = [] } = useGetUserGroupQuery(inf?.id, {
		skip: !inf?.id,
	});

	let { data: GroupDevices, refetch: RefetchGroups } =
		useGetDevicesByGroupQuery(userid, {
			skip: !filter || userid === undefined,
		});

	let { handleFocusClick } = useContext(draggablecontext);
	const { ObjectsearchQuery, setTrackingTypeIds, parentCheck } =
		useContext(filtrationcontext);

	let {
		data,
		isLoading,
		refetch: RefetchDevices,
	} = useGetUsersDeviceQuery(
		{ userId: userid, type: trackingType },
		{ skip: !userid || !trackingType },
	);

	const positions = useSelector((state) => state.webSocket.positions);
	const devices = useSelector((state) => state.webSocket.devices);
	const map = useMap();

	const scrollRef = useRef(null);
	const [loadedIndexes, setLoadedIndexes] = useState(new Set());

	const [startIndex, setStartIndex] = useState(0);
	const [visibleCount, setVisibleCount] = useState(0);

	const handleScroll = () => {
		const scrollTop = scrollRef.current.scrollTop;
		const newStart = Math.floor(scrollTop / ITEM_HEIGHT);
		if (newStart !== startIndex) {
			setStartIndex(newStart);
		}
	};
	const visibleStart = Math.max(0, startIndex - BUFFER);
	const visibleEnd = startIndex + visibleCount + BUFFER;
	useEffect(() => {
		const updateVisibleCount = () => {
			const width = window.innerWidth;

			if (width >= 4000) {
				setVisibleCount(35);
			} else if (width >= 1400) {
				setVisibleCount(15);
			} else if (width >= 992) {
				setVisibleCount(10);
			} else if (width >= 768) {
				setVisibleCount(7);
			} else {
				setVisibleCount(5); // fallback
			}
		};

		// Set on initial load
		updateVisibleCount();

		// Update on resize
		window.addEventListener("resize", updateVisibleCount);
		return () => window.removeEventListener("resize", updateVisibleCount);
	}, []);

	useEffect(() => {
		if (
			shownDataByUser?.filter((item) =>
				item.disabled === false && filter
					? item.groupId !== 0
					: item.groupId === 0 || unGroupedVehicles(item.groupId),
			).length < visibleCount
		) {
			setContainerHeight(ITEM_HEIGHT * shownDataByUser?.length);
		} else {
			setContainerHeight(ITEM_HEIGHT * visibleCount);
		}
	}, [shownDataByUser?.length]);
	useEffect(() => {
		const filteredIds =
			(parentCheck?.length === 0
				? shownDataByUser
						?.filter((item) => item.groupId === 0)
						?.map((item) => item.id)
				: shownDataByUser
						?.filter((item) => parentCheck.includes(item.groupId))
						?.map((item) => item.id)) || [];

		setTrackingTypeIds((prev) => {
			// ✅ If parentCheck > 0 → append to previous
			if (parentCheck?.length > 0) {
				const combined = [...(prev || []), ...filteredIds];
				return Array.from(new Set(combined)); // ✅ unique list
			}

			// ✅ If parentCheck empty → start fresh
			return filteredIds;
		});
	}, [shownDataByUser, parentCheck]);
	const unGroupedVehicles = (groupId) => {
		if (!Groups || Groups.length === 0) {
			return true;
		} else {
			return !Groups.some((g) => g.id === groupId);
		}
	};
	// useEffect(() => {
	// 	setShownData(filteredData);
	// }, [filteredData]);

	useEffect(() => {
		if (trackingType) setTrackingTypeIds([]);
	}, [trackingType]);

	useEffect(() => {
		return () => setSearchQuery("");
	}, [setSearchQuery]);
	useEffect(() => {
		const newData = !filter
			? data
			: GroupDevices?.filter((item) => {
					const deviceType = item?.attributes?.device_type;

					if (trackingType === "mobility") {
						return deviceType === "mobile";
					}

					if (trackingType === "vehicle") {
						return !deviceType;
					}

					return true;
				});
		let filteredData = newData?.filter((devices) => {
			const matchesSearch = ObjectsearchQuery
				? devices.name.toLowerCase().includes(ObjectsearchQuery.toLowerCase())
				: true;
			return matchesSearch;
		});
		setShownData((prev) => ({
			...prev,
			[userid]: filteredData || [],
		}));
	}, [
		ObjectsearchQuery,
		filter,
		data,
		GroupDevices,
		trackingType,
		setShownData,
	]);

	useEffect(() => {
		if (objectselect === false) {
			setSelectedId(null);
			setHistoryPlayback({ state: false, Id: null });
		}
	}, [objectselect]);

	const handleRowClick = useCallback(
		async (id, lat, lon, imei, groupname) => {
			if (multipleSelect) {
				return;
			} else {
				if (id === selectedId) {
					setSelectedId(null);
					setObjectselect(false);
					setImei(null);
					setHistoryPlayback({ state: false, Id: null });
				} else {
					await handleClose("objectSelected");
					await setObjectselect(false);
					setSelectedId(id);
					setObjectselect(true);
					setImei(imei);
					setHistoryPlayback({ state: true, Id: id });

					const targetCoordinates = lat && lon ? [lat, lon] : [33, 30];
					map.setView(targetCoordinates, 13);
					map.scrollWheelZoom.disable();
					handleShowObject();
				}
			}
		},
		[
			selectedId,
			setObjectselect,
			setHistoryPlayback,
			handleClose,
			map,
			handleShowObject,
			setImei,
			multipleSelect,
		],
	);

	useEffect(() => {
		if (reloadData) {
			RefetchDevices();
			RefetchGroups();
			setReloadData(false);
		}
	}, [reloadData]);

	const deviceMap = useMemo(() => {
		const map = new Map();
		devices?.forEach((d) => map.set(d.id, d));
		return map;
	}, [devices]);

	const positionMap = useMemo(() => {
		const map = new Map();
		positions?.forEach((p) => map.set(p.deviceId, p));
		return map;
	}, [positions]);

	if (isLoading)
		return (
			<div
				style={{
					height: `calc(calc(100vh - 117px) - 229px)`,
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<Loader />
			</div>
		);

	if (shownDataByUser?.length === 0) {
		return (
			<div className="my-2 p-2">
				<div className="text-center text-success fs-16 fw-700">
					{trans("No data shown")}
				</div>
			</div>
		);
	}
	console.log("Shown Data By User", shownDataByUser);
	const totalHeight =
		shownDataByUser?.filter((item) =>
			item.disabled === false && filter
				? item.groupId !== 0
				: item.groupId === 0 || unGroupedVehicles(item.groupId),
		)?.length * ITEM_HEIGHT;
	const renderHeight = Math.min(containerHeight, totalHeight);
	const lang = localStorage.getItem("lang") || "en";
	console.log("vehiclesIds", vehiclesIds);
	console.log("Shown Data", shownData);
	return (
		<>
			<div
				ref={scrollRef}
				onScroll={handleScroll}
				style={{
					height: !filter
						? `calc(calc(100vh - 117px) - 229px)`
						: `${
								shownDataByUser?.filter((item) =>
									item.disabled === false && filter
										? item.groupId !== 0
										: item.groupId === 0 || unGroupedVehicles(item.groupId),
								)?.length * ITEM_HEIGHT
							}px`,
					overflowY: "auto",
					position: "relative",
				}}
			>
				<div
					style={{
						height: `${
							shownDataByUser?.filter((item) =>
								item.disabled === false && filter
									? item.groupId !== 0
									: item.groupId === 0 || unGroupedVehicles(item.groupId),
							)?.length * ITEM_HEIGHT
						}px`,
						position: "relative",
					}}
				>
					{shownDataByUser
						?.filter((item) =>
							item.disabled === false && filter
								? item.groupId !== 0
								: item.groupId === 0 || unGroupedVehicles(item.groupId),
						)
						?.slice(visibleStart, visibleEnd)
						.map((i, relIndex) => {
							const index = visibleStart + relIndex;
							const device = deviceMap.get(i.id);
							const position = positionMap.get(i.id);

							return (
								<div
									key={i.id}
									className={`tracked-table-row`}
									onClick={() =>
										handleRowClick(
											i.id,
											position?.latitude ?? 24.7136,
											position?.longitude ?? 46.6753,
											i?.uniqueId,
											i?.groupId,
										)
									}
									style={{
										position: "absolute",
										top: `${index * ITEM_HEIGHT}px`,
										width: "100%",
										backgroundColor: i.uniqueId === imei && "#eaf4ec",
									}}
								>
									<div
										className="tracked-vehicle-name d-inline"
										title={i?.name}
									>
										{multipleSelect && (
											<Checkbox
												onChange={() => {
													setVehicleIds((prev) => {
														if (prev.some((item) => item.id === i.uniqueId)) {
															return prev.filter(
																(item) => item.id !== i.uniqueId,
															);
														} else {
															return [
																...prev,
																{ id: i.uniqueId, name: i.name },
															];
														}
													});
												}}
												checked={vehiclesIds?.some(
													(item) => item.id === i.uniqueId,
												)}
												className={`${lang === "en" ? "me-2" : "ms-2"}`}
											/>
										)}
										{i?.name}
									</div>
									<div
										className={`tracked-vehicle-status ${
											multipleSelect ? "row-muted" : ""
										}`}
										title={device?.status === "online" ? "Online" : "Offline"}
									>
										<img
											src={`${process.env.PUBLIC_URL}/assets/New/LiveTracking/${
												device?.status === "online"
													? "WifiOnline"
													: "WifiOffline"
											}.svg`}
											alt="status"
										/>
									</div>
									<div
										className={`tracked-eye-focus ${
											multipleSelect ? "row-muted" : ""
										}`}
										onClick={(e) => {
											if (multipleSelect) {
												return;
											} else {
												e.stopPropagation();
												handleFocusClick(i.id, i?.uniqueId, i);
											}
										}}
									>
										<img
											src={`${process.env.PUBLIC_URL}/assets/Eye.svg`}
											alt="Eye Icon"
											title={trans("Multi-view")}
										/>
									</div>
								</div>
							);
						})}
				</div>
			</div>
		</>
	);
}
